import { useRef } from "react";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { RouteGuardPermissions } from "@/components/permissions/route-guard-multiple";
import { PurchaseOrderForm } from "@/components/purchase-orders/purchase-order-form";
import { Id } from "@/convex/_generated/dataModel";

export const Route = createFileRoute("/_authenticated/purchase-orders/new")({
  validateSearch: (search: Record<string, unknown>) => ({
    draft: typeof search.draft === "string" ? search.draft : undefined,
  }),
  component: NewPurchaseOrderPage,
});

function NewPurchaseOrderPage() {
  const { draft } = Route.useSearch();
  const navigate = useNavigate();

  // Capturamos el ?draft SOLO al montar: si la página se recarga con un
  // borrador ya creado, hidratamos ese; si es creación nueva, el form crea el
  // borrador y sincronizamos el param in-place (sin remontar).
  const coldDraftRef = useRef(draft);

  return (
    <RouteGuardPermissions
      permissions={[{ module: "purchase_orders", actions: ["create"] }]}
    >
      <PurchaseOrderForm
        purchaseOrderId={
          coldDraftRef.current
            ? (coldDraftRef.current as Id<"purchase_orders">)
            : undefined
        }
        onDraftCreated={(id) =>
          navigate({
            to: "/purchase-orders/new",
            search: { draft: id },
            replace: true,
          })
        }
      />
    </RouteGuardPermissions>
  );
}
